import { render, staticRenderFns } from "./EditCarryDialog.vue?vue&type=template&id=b8b83f42&"
import script from "./EditCarryDialog.vue?vue&type=script&lang=js&"
export * from "./EditCarryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports